<template>
  <div class="modal-overlay" @click="$emit('close')">
    <div class="modal-content" @click.stop>
      <h3>
        {{
          editingIndex !== null
            ? "ショートカットを編集"
            : "ショートカットを追加"
        }}
      </h3>
      <form @submit.prevent="handleSubmit">
        <div class="form-group">
          <label for="linkName">タイトル:</label>
          <input
            id="linkName"
            v-model="form.name"
            type="text"
            placeholder="例：GitHub"
            required
          />
        </div>
        <div class="form-group">
          <label for="linkUrl">URL:</label>
          <input
            id="linkUrl"
            v-model="form.url"
            type="url"
            placeholder="https://example.com"
            required
          />
        </div>
        <div class="form-group">
          <label for="linkIcon">Font Awesomeクラス (オプション):</label>
          <input
            id="linkIcon"
            v-model="form.icon"
            type="text"
            placeholder="例: fab fa-github"
          />
        </div>
        <div class="form-buttons">
          <button type="submit" class="btn-primary">
            {{ editingIndex !== null ? "保存" : "追加" }}
          </button>
          <button type="button" class="btn-secondary" @click="$emit('close')">
            キャンセル
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import type { ShortcutLink } from "@/types/models";

interface Props {
  link: ShortcutLink | null;
  index: number | null;
}

const props = defineProps<Props>();
const emit = defineEmits<{
  save: [link: ShortcutLink];
  close: [];
}>();

const form = ref<ShortcutLink>({
  name: "",
  url: "",
  icon: "fas fa-link",
});

const editingIndex = computed(() => props.index);

onMounted(() => {
  if (props.link) {
    form.value = { ...props.link };
  }
});

const handleSubmit = (): void => {
  if (!form.value.name || !form.value.url) {
    alert("タイトルと URL を入力してください");
    return;
  }
  emit("save", {
    name: form.value.name,
    url: form.value.url,
    icon: form.value.icon || "fas fa-link",
  });
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  padding: 24px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

h3 {
  margin: 0 0 20px 0;
  font-size: 16px;
  color: #202124;
}

form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

label {
  font-size: 12px;
  font-weight: 600;
  color: #5f6368;
}

input {
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s;
}

input:focus {
  outline: none;
  border-color: #1f73e6;
  box-shadow: 0 0 4px rgba(31, 115, 230, 0.3);
}

.form-buttons {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 8px;
}

button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-primary {
  background: #1f73e6;
  color: white;
}

.btn-primary:hover {
  background: #1557b0;
}

.btn-secondary {
  background: #e0e0e0;
  color: #202124;
}

.btn-secondary:hover {
  background: #d0d0d0;
}
</style>
